module.exports = __webpack_public_path__ + "img/Group_28473.a3aee90e.png";